import React from "react";
import Login from "../screens/Auth/Login";
import OTPScreen from "../screens/Auth/OtpScreen";
import { Route, Routes } from "react-router-dom";
const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/otpScreen" element={<OTPScreen />} />
    </Routes>
  );
};

export default AuthRoutes;
